import { Http,Headers, RequestOptions } from '@angular/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';

// Observable class extensions
import 'rxjs/add/observable/of';
import 'rxjs/add/observable/throw';
import 'rxjs/add/observable/fromPromise';
 
// Observable operators
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/debounceTime';
import 'rxjs/add/operator/distinctUntilChanged';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/filter';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/mergeMap';
import 'rxjs/add/operator/switchMap';
import 'rxjs/add/operator/toPromise';
import { HttpHeaders } from '@angular/common/http';

@Injectable()
export class NbAuthService {

  private readonly url_login = 'https://api.beforeyourflight.com/api/login';
  private readonly url_forgot = 'https://api.beforeyourflight.com/forgot';
  
  constructor(private http: Http) { 
  }
  
  login(user): Observable<any>{
    let myHeaders = new Headers({ 'Content-Type': 'application/json'});

    var data = {
          email : user.email,
          password : user.password
    };
    return this.http
      .post( this.url_login, JSON.stringify(data),{ headers : myHeaders } )
      .map(response => response)
      .catch(error => error);
  }
  
  forgot(user): Observable<any>{
    let myHeaders = new Headers({ 'Content-Type': 'application/json'});

    var data = {
          email : user.email
    };
    return this.http
      .post( this.url_forgot, JSON.stringify(data),{ headers : myHeaders } )
      .map(response => response)
      .catch(error => error);
  }

/*
  logout(a,b){}
  requestPassword(a,b){}
  resetPassword(a,b){}
*/
}